import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import CategoryHeader from "./CategoryHeader";
import BackBtn from "./BackBtn";

function SubCategory(props) {
  const articleId = useParams();
  const [categoryName, setCategoryName] = useState(0);
  const [categoryParent, setCategoryParent] = useState(0);
  const fetchSettings = props.data.settings;
  const fetchCategories = props.data.content.categories;
  const fetchArticles = props.data.content.articles;
  let str = window.location.href;
  let arr = str.split("/");

  useEffect(() => {
    setCategoryName(articleId.category.replace(/-/g, " "));
    setCategoryParent(arr[arr.length - 2]);
    document.body.className = "search-shrink";
    return () => {
      document.body.className = "";
    };
  }, []);

  return (
    <section className="subcategory">
      <div className="subcategory-content">
        <BackBtn />
        <ul className="breadcrumbs">
          <li>
            <Link to="/">{fetchSettings.site}</Link>
          </li>
          <li>
            <Link to={`/category/${categoryParent}`}>{categoryParent}</Link>
          </li>
          <li>{categoryName}</li>
        </ul>

        <CategoryHeader
          title={
            fetchCategories
              .find((post) => post.category == categoryParent)
              ?.subcategories.find(
                (post) => post.category == articleId.category
              )?.title
          }
          description={
            fetchCategories
              .find((post) => post.category == categoryParent)
              ?.subcategories.find(
                (post) => post.category == articleId.category
              )?.text
          }
          icon={`${
            fetchCategories.find((post) => post.category == categoryParent)?.svg
          }`}
          color={
            fetchCategories.find((post) => post.category == categoryParent)
              ?.color
          }
        />

        <div className="content-split">
          <div className="sidebar">
            <button className="sidebarOpenMobile">
              <span>Articles in this section</span>
              <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M15.25 10.75L12 14.25L8.75 10.75"
                ></path>
              </svg>
            </button>
            <ul className="sidebarLinks">
              {fetchCategories
                .find((post) => post.category == categoryParent)
                ?.subcategories?.map((subcategory) => (
                  <Link
                    key={subcategory.id}
                    to={`/category/${categoryParent}/${subcategory.category}`}
                    className={
                      subcategory.title ==
                      fetchCategories
                        .find((post) => post.category == categoryParent)
                        ?.subcategories.find(
                          (post) => post.category == articleId.category
                        )?.title
                        ? "active"
                        : ""
                    }
                  >
                    {subcategory.title}
                  </Link>
                ))}
            </ul>
          </div>
          <div className="content">
            <ul className="listArticles">
              {fetchArticles
                .filter(
                  (post) =>
                    post.categoryId ==
                      fetchCategories.find(
                        (post) => post.category == categoryParent
                      )?.id &&
                    post.subcategoryId ==
                      fetchCategories
                        .find((post) => post.category == categoryParent)
                        ?.subcategories.find(
                          (post) => post.category == articleId.category
                        )?.id
                )
                .map((post) => (
                  <li key={post.id}>
                    <Link to={`/article/${post.url}/${post.id}`}>
                      {post.question}
                    </Link>

                    {/* {fetchCategories[post.categoryId]
                      .subcategories[post.subcategoryId] ? (
                      <span className="badge">
                        {
                          fetchCategories[post.categoryId]
                            .subcategories[post.subcategoryId]?.category
                        }
                      </span>
                    ) : (
                      ""
                    )} */}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SubCategory;
